require('./brokerHireDerivativesAccountSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const Immutable = require('immutable');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @constants
const { FIRST_STEP } = require('constants/index');

const CLASS_NAME = 'broker-hire-derivatives-account-success';
const CHECK_ORDER_URL = '/myprofile/broker';
const GO_TO_MY_WALLET_URL = '/myprofile/broker';

class BrokerHireDerivativesAccountSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.buildHeader = this.buildHeader.bind(this);
        this.buildField = this.buildField.bind(this);
        this.buildLeftColumnDetails = this.buildLeftColumnDetails.bind(this);
        this.buildRightColumnDetails = this.buildRightColumnDetails.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
    }

    buildField(primaryText, secondaryText, description = <span>&nbsp;</span>, primaryTextInjectStrings = []) {
        return (
            <div className={`${CLASS_NAME}__details-field`}>
                <h5 className={`${CLASS_NAME}__details-primary-text`}>
                    <FormattedText
                        value={primaryText}
                        format="uppercase"
                        injectedStrings={primaryTextInjectStrings}
                    />
                </h5>
                <div className={`${CLASS_NAME}__details-secondary-text`}>
                    {secondaryText}
                </div>
                <div className={`${CLASS_NAME}__details-gray`}>
                    {description}
                </div>
            </div>
        );
    }

    buildFooter() {
        return (
            <div>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <span className={`${CLASS_NAME}__corporates-operations-button`}>
                        <OKButton
                            modifier="ghost"
                            to={CHECK_ORDER_URL}
                        >
                            <FormattedText
                                value="hireDerivativesAccount-checkOrder"
                            />
                        </OKButton>
                    </span>
                    <OKButton
                        modifier="secondary"
                        to={GO_TO_MY_WALLET_URL}
                    >
                        <FormattedText
                            value="hireDerivativesAccount-goToMyWallet"
                        />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildHeader() {
        return (
            <div className="wizard-success-step__highlight">
                <i className="wizard-success-step__success-icon" />
                <div className="wizard-success-step__messages">
                    <OKBoxTitle
                        value={formatText('hireDerivativesAccount-successTitle')}
                    />
                </div>
            </div>
        );
    }

    buildLeftColumnDetails() {
        const { immBrokerHireDerivativesAccount, immBrokerWallets } = this.props;

        const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
            ['steps', FIRST_STEP, 'selectedAssociatedContract']
        );
        const immSelectedAssociatedAccount = immBrokerHireDerivativesAccount.getIn(
            ['contracts', selectedAssociatedContract]
        );
        const immOwner = immBrokerWallets.get('allFuturesList').find(
            immFutures => immFutures.getIn(['cviejo', 'numerodecontrato']) == immSelectedAssociatedAccount.get('contractNumber')
        ) || Immutable.fromJS({});

        const associatedAccountField = this.buildField(
            'hireDerivativesAccount-contractInterveners',
            immSelectedAssociatedAccount.get('accountType'),
            immOwner.getIn(['ibanComplex', 'codbban'])
        );

        const owner = (
            <FormattedText
                value="hireDerivativesAccount-firstOwner"
                injectedStrings={[
                    immOwner.get('nombretitular', '').trim(),
                    immOwner.getIn(['descIntervenciones', 'nomTipInterv'], '').trim()
                ]}
            />
        );

        const amountObject = {
            amount: immOwner.getIn(['saldoActual', 'importe']),
            currency: immOwner.getIn(['saldoActual', 'divisa'])
        };
        const plainAmountObject = getPlainAmountObject(amountObject);
        const balanceSymbol = (
            <OneLineSymbolAmount
                amountObject={plainAmountObject}
                language={getLanguage()}
                amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
        );

        const balance = (
            <FormattedTextWithComponents
                value="hireDerivativesAccount-balanceAccount"
                injectedComponents={[balanceSymbol]}
            />
        )

        return (
            <div className={`${CLASS_NAME}__details-section-left`}>
                {associatedAccountField}
                <div className={`${CLASS_NAME}__details-gray`}>
                    <div className={`${CLASS_NAME}__details-field`}>
                        {owner}
                        <br />
                        {balance}
                    </div>
                </div>
            </div>
        );
    }

    buildRightColumnDetails() {
        const { immBrokerHireDerivativesAccount } = this.props;

        const immFirstStepInterveners = immBrokerHireDerivativesAccount.getIn(
            ['steps', FIRST_STEP, 'interveners']
        );

        const interveners = immFirstStepInterveners.map((immIntervener, key) => {
            return (
                <div key={key}>
                    <div className={`${CLASS_NAME}__details-secondary-text`}>
                        {immIntervener.get('name')}
                    </div>
                    <div className={`${CLASS_NAME}__details-gray`}>
                        {immIntervener.get('type')}
                    </div>
                </div>
            );
        });

        return (
            <div className={`${CLASS_NAME}__details-section-right`}>
                <div className={`${CLASS_NAME}__details-field`}>
                    <h5 className={`${CLASS_NAME}__details-primary-text`}>
                        <FormattedText
                            value="hireDerivativesAccount-interveners"
                            format="uppercase"
                        />
                    </h5>
                    {interveners}
                </div>
            </div>
        );
    }

    render() {
        return (
            <ContentBox>
                <h3><FormattedText value="hireDerivativesAccount-successEndOperation" /></h3>
                {this.buildHeader()}
                <h4 className={`${CLASS_NAME}__details-title`}>
                    <FormattedText value="hireDerivativesAccount-successContractedAccountInformation" />
                </h4>
                <div className={`row ${CLASS_NAME}__details-container`}>
                    <div className="col-xs-4">
                        {this.buildLeftColumnDetails()}
                    </div>
                    <div className="col-xs-8">
                        {this.buildRightColumnDetails()}
                    </div>
                </div>
                {this.buildFooter()}
            </ContentBox>
        );
    }
}

BrokerHireDerivativesAccountSuccess.propTypes = {
    immBrokerHireDerivativesAccount: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired
};

module.exports = BrokerHireDerivativesAccountSuccess;
